import { OrganizationType } from "shared-core/types/organization.ts";

export function getOrganizationTranslationValues(
  organizationType: OrganizationType | null | undefined,
  translate: (key: string) => string,
): Record<string, string> {
  const organization =
    organizationType === OrganizationType.PERSONAL ? "household" : "company";
  const organizationKeys = {
    yourOrganization: `common.your_${organization}`,
    anOrganization: `common.a_${organization}`,
    theOrganization: `common.the_${organization}`,
    organization: `common.${organization}`,
    organizations: `common.${organization === "household" ? "households" : "companies"}`,
    anOrganizationMember: `common.a_${organization}_member`,
    organizationMember: `common.${organization}_member`,
    organizationMembers: `common.${organization}_members`,
    yourOrganizationMembers: `common.your_${organization}_members`,
  };
  const values: Record<string, string> = {};
  for (const [name, translationKey] of Object.entries(organizationKeys)) {
    values[name] = translate(translationKey);
    values[`${name}Key`] = translationKey;
  }
  return values;
}
